import Vue from 'vue'
import VueResource from 'vue-resource'
import App from './components/App'
import store from './store'
import GmapCluster from 'vue2-google-maps/dist/components/cluster'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.config.productionTip = true

Vue.use(VueResource)

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBJZKsCxEJs6aR3ud46qY4uy4lgnEw-AhY',
    libraries: 'places,visualization,geometry'
  }
})

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.component('GmapCluster', GmapCluster)

// eslint-disable-next-line
new Vue({
  el: '#app',
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js